// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --icon-valid: url(/assets/icons/i-valid.svg);
  --icon-invalid: url(/assets/icons/i-invalid.svg);
}

.mat-mdc-form-field {
  padding: 10px;
}
.mat-mdc-form-field .mat-mdc-form-field-infix {
  padding: 7px 0 3px;
}
.mat-mdc-form-field .mat-mdc-form-field-error {
  text-align: right;
}

.login-form {
  text-align: left;
}
.login-form .paragraph {
  margin-top: 0;
}
@media screen and (max-width: 480px) {
  .login-form .paragraph {
    font-size: 12px;
  }
}
.login-form .paragraph span {
  color: rgb(194, 27, 23);
}
.login-form .required-field-pharagraph-big {
  width: 100%;
  margin-bottom: 15;
}
.login-form .required-field-pharagraph-small {
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 14px;
}
.login-form .disabled {
  color: rgb(214, 219, 225);
}

.column-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.column-container .contact-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 10px 5px 10px;
  width: 100%;
}
.column-container .contact-container .column-inner-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: 150px;
}
.column-container .contact-container .column-inner-container.right {
  justify-content: flex-start;
}
@media screen and (max-width: 1220px) {
  .column-container .contact-container .column-inner-container {
    width: 250px;
  }
}
@media screen and (max-width: 795px) {
  .column-container .contact-container .column-inner-container {
    margin: 0 auto;
    justify-content: space-around;
    width: 300px;
  }
}
@media screen and (max-width: 1220px) {
  .column-container .contact-container {
    margin: 15px 0 20px;
  }
}
@media screen and (max-width: 795px) {
  .column-container .contact-container {
    flex-direction: column;
  }
}
.column-container .message-container {
  margin: 16px 0 0px;
  width: 100%;
}
.column-container .message-container .paragraph {
  margin-bottom: 1px;
  font-size: 11px;
  text-align: center;
}
.column-container .message-container h4 {
  text-align: center;
  font-size: 17px;
  font-family: "Roboto-Bold";
  line-height: 19px;
  color: rgb(194, 27, 23);
  padding-bottom: 20px;
  cursor: pointer;
}
.column-container .column-radio-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
}
.column-container .column-radio-container .radio-label {
  font-family: "Roboto-Bold";
  color: rgb(194, 27, 23);
  padding: 8px 0;
}
.column-container .column-radio-container .radio-button {
  padding: 10px 0;
}
.column-container .contact-column {
  width: 45%;
  min-width: 210px;
  margin: 5px 5px;
}
@media screen and (max-width: 720px) {
  .column-container .contact-column {
    margin: 0;
  }
}
.column-container .contact-column .column-field {
  width: 100%;
  height: 84px;
}
@media screen and (max-width: 720px) {
  .column-container .contact-column {
    width: 100%;
  }
}
@media screen and (max-width: 720px) {
  .column-container {
    flex-direction: column;
  }
}

.contact-form-picture-container {
  position: relative;
  float: left;
  width: 60%;
  height: 100vh;
  padding-top: 20px;
}
@media screen and (max-width: 1000px) {
  .contact-form-picture-container {
    display: none;
  }
}
.contact-form-picture-container .contact-form-picture {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
@media screen and (max-width: 1000px) {
  .contact-form-picture-container .contact-form-picture {
    display: none;
  }
}
.contact-form-picture-container .concept-pv-grey {
  position: absolute;
  left: -50px;
  top: 220px;
  background-size: 100%;
}
@media screen and (max-width: 1220px) {
  .contact-form-picture-container .concept-pv-grey {
    width: 300px;
  }
}
@media screen and (max-width: 1000px) {
  .contact-form-picture-container .concept-pv-grey {
    display: none;
  }
}

.contact-form-container {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px 80px;
  justify-content: flex-start;
  width: 42%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);
  height: 100vh;
}
@media (max-width: 1000px) {
  .contact-form-container {
    box-shadow: none;
  }
}
@media (min-width: 795px) {
  .contact-form-container {
    overflow: auto;
  }
}
.contact-form-container hr {
  margin-top: 20px;
}
@media screen and (max-width: 1220px) {
  .contact-form-container {
    padding-bottom: 20px;
  }
  .contact-form-container.container-error {
    width: 100%;
  }
}
@media screen and (max-width: 795px) {
  .contact-form-container {
    height: auto;
    max-height: 100vh;
    width: 90%;
    padding: 40px 5px 0;
  }
}
@media screen and (max-width: 400px) {
  .contact-form-container {
    width: 100%;
  }
}
@media screen and (max-width: 720px) {
  .contact-form-container {
    max-height: max-content;
  }
}

.main-title {
  text-align: left;
}
@media screen and (max-width: 480px) {
  .main-title {
    text-align: center;
    width: 80%;
    margin: 0 auto;
    padding-bottom: 5px;
    font-size: 21px;
  }
}
.main-title.error-title {
  text-align: center;
}

.main-subtitle {
  text-align: left;
  padding-bottom: 20px;
}
@media screen and (max-width: 480px) {
  .main-subtitle {
    text-align: center;
  }
}
.main-subtitle.error-subtitle {
  text-align: center;
}

re-captcha {
  margin-top: 20px;
}

.error {
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.recaptcha-container {
  margin: 25px 0 0;
  display: flex;
  justify-content: space-evenly;
}

.cellphone-hint {
  font: 14px "Roboto-Bold";
  color: rgb(111, 112, 114);
}

::ng-deep .mat-select-value-text {
  color: rgb(111, 112, 114);
}

.profitability-container {
  padding: 12px;
  box-shadow: 0px 0px 1px rgba(96, 112, 129, 0.05), 0px 1px 4px rgba(96, 112, 129, 0.1);
  border-radius: 10px;
  width: 100%;
  background: rgb(247, 247, 247);
}
.profitability-container .profitability-title {
  font-size: 10px;
  color: rgb(96, 112, 129);
  font-style: normal;
  line-height: 12px;
  margin: 0 !important;
  font-weight: 400px;
}
.profitability-container .profitability-content {
  font-size: 10px;
  font-weight: 100 !important;
  line-height: 12px;
  font-style: normal;
  margin-top: 7px;
}
.profitability-container .profitability-link {
  font-size: 10px;
  text-decoration: underline;
}
@media screen and (max-width: 795px) {
  .profitability-container {
    width: auto;
  }
}
@media (max-width: 1000px) {
  .profitability-container {
    margin: 0 10px 20px 10px;
    padding-bottom: 7px;
  }
}

.btn-alternative {
  position: absolute;
  z-index: 2;
  top: 20px;
  left: 4%;
  background: rgb(117, 33, 39);
  color: white;
  width: 93px;
  height: 42px;
  border-radius: 25px;
}

.form-subtitle {
  margin: 0px 0px;
  font-style: normal;
}
@media (max-width: 1000px) {
  .form-subtitle {
    margin: 0px 40px !important;
  }
}

hr {
  border: 0.51px solid rgb(237, 237, 237);
  width: auto;
  margin: 46px 30px 20px 30px;
}

::ng-deep .mat-mdc-tab-group {
  margin-top: 20px;
}
::ng-deep .mat-mdc-tab-group .mat-mdc-tab-header {
  border-bottom: none !important;
  gap: 0px;
  background: #D9D9D9;
  border-radius: 43px;
}
::ng-deep .mat-mdc-tab-group .mat-mdc-tab-labels .mdc-tab {
  margin: 4.5px;
  width: min-content;
  background: white;
  border-radius: 25px;
  color: rgb(66, 66, 67);
  height: 42px;
}
::ng-deep .mat-mdc-tab-group .mat-mdc-tab-labels .mdc-tab .mdc-tab-label-content {
  white-space: initial;
}
::ng-deep .mat-mdc-tab-group .mat-mdc-tab-labels .mdc-tab.mdc-tab--active {
  background: rgb(142, 42, 42) !important;
}
::ng-deep .mat-mdc-tab-group .mat-mdc-tab-labels .mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: white;
}
@media screen and (max-width: 512px) {
  ::ng-deep .mat-mdc-tab-group .mat-mdc-tab-labels .mdc-tab {
    font-size: 14px;
  }
}
::ng-deep .mat-mdc-tab-group .mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination {
  display: none;
}

::ng-deep .mat-ink-bar {
  visibility: hidden !important;
}

@media (max-width: 512px) {
  ::ng-deep .mdc-tab {
    font-size: 12px !important;
  }
}

.disclaimer {
  text-align: center;
  padding: 10px 0px 0px 0px;
  width: 100%;
}
@media (max-width: 1000px) {
  .disclaimer {
    padding: 0px 15px;
    width: auto;
  }
}
.disclaimer p {
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
}
.disclaimer a {
  font-size: 14px;
  font-weight: 100;
}

.actions {
  width: auto;
  max-width: 100%;
  text-align: center;
  padding: 0px 10px;
}
.actions .btn-large {
  width: auto !important;
  min-width: 100%;
}

.info-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 74px 0;
}
.info-container .info-title {
  text-align: center;
  height: 46px;
  font-weight: 400;
  font-size: 22px;
  line-height: 23px;
  width: 320.64px;
  color: rgb(194, 27, 23);
}
.info-container .info-description {
  text-align: center;
  width: 352px;
  height: 64px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgb(111, 112, 114);
}

app-profitability-disclaimer {
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/modules/login/online/online.component.scss"],"names":[],"mappings":"AAoHA;EACE,4CAAA;EACA,gDAAA;ACnHF;;AADA;EACE,aAAA;AAIF;AAFE;EAA4B,kBAAA;AAK9B;AAJE;EAA4B,iBAAA;AAO9B;;AAJA;EACE,gBAAA;AAOF;AANE;EACE,aAAA;AAQJ;AAPI;EAFF;IAEgD,eAAA;EAWhD;AACF;AAXI;EACE,uBDVQ;ACuBd;AATE;EACE,WAAA;EACA,iBAAA;AAWJ;AARE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAUJ;AAPE;EACE,yBDEa;ACOjB;;AALA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAQF;AANE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;EACA,WAAA;AAQJ;AANI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;AAQN;AANM;EACE,2BAAA;AAQR;AALM;EAXF;IAYI,YAAA;EAQN;AACF;AANM;EAfF;IAgBI,cAAA;IACA,6BAAA;IACA,YAAA;EASN;AACF;AANI;EA7BF;IA8BI,mBAAA;EASJ;AACF;AAPI;EAjCF;IAkCI,sBAAA;EAUJ;AACF;AANE;EACE,kBAAA;EACA,WAAA;AAQJ;AAPI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AASN;AAPI;EACE,kBAAA;EACA,eAAA;EACA,0BDuDM;ECtDN,iBAAA;EACA,uBDxFQ;ECyFR,oBAAA;EACA,eAAA;AASN;AALE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAOJ;AANE;EACE,0BD0CQ;ECzCR,uBDpGU;ECqGV,cAAA;AAQJ;AALI;EACE,eAAA;AAON;AAHE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AAKJ;AAHI;EALF;IAMI,SAAA;EAMJ;AACF;AAJI;EACE,WAAA;EACA,YAAA;AAMN;AAHI;EAdF;IAciD,WAAA;EAOjD;AACF;AALE;EA/FF;IAgGI,sBAAA;EAQF;AACF;;AALA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;AAQF;AANE;EAPF;IAOiD,aAAA;EAU/C;AACF;AAVE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAYJ;AAVI;EARF;IAQiD,aAAA;EAcjD;AACF;AAbE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AAeJ;AAdI;EALF;IAMI,YAAA;EAiBJ;AACF;AAhBI;EARF;IAQiD,aAAA;EAoBjD;AACF;;AAjBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,UAAA;EACA,2CAAA;EACA,aAAA;AAoBF;AAlBE;EAVF;IAWI,gBAAA;EAqBF;AACF;AAnBE;EAdF;IAeI,cAAA;EAsBF;AACF;AApBE;EACE,gBAAA;AAsBJ;AAnBE;EAtBF;IAuBI,oBAAA;EAsBF;EArBE;IACE,WAAA;EAuBJ;AACF;AApBE;EA7BF;IA8BI,YAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAuBF;AACF;AArBE;EApCF;IAqCI,WAAA;EAwBF;AACF;AAtBE;EAxCF;IAyCI,uBAAA;EAyBF;AACF;;AAvBA;EACE,gBAAA;AA0BF;AAxBE;EAHF;IAII,kBAAA;IACA,UAAA;IACA,cAAA;IACA,mBAAA;IACA,eAAA;EA2BF;AACF;AA1BE;EACE,kBAAA;AA4BJ;;AAzBA;EACE,gBAAA;EACA,oBAAA;AA4BF;AA1BE;EAJF;IAKI,kBAAA;EA6BF;AACF;AA5BE;EACE,kBAAA;AA8BJ;;AA1BA;EAAa,gBAAA;AA8Bb;;AA5BA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AA+BF;;AA5BA;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;AA+BF;;AA3BA;EACE,wBAAA;EACA,yBD5Pa;AC0Rf;;AA3BA;EACE,yBDhQa;AC8Rf;;AA3BA;EACE,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,WAAA;EACA,8BD9Le;AC4NjB;AA5BE;EACE,eAAA;EACA,wBDvMY;ECwMZ,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AA8BJ;AA5BE;EACE,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA8BJ;AA5BE;EACE,eAAA;EACA,0BAAA;AA8BJ;AA3BE;EA3BF;IA4BI,WAAA;EA8BF;AACF;AA5BE;EA/BF;IAgCI,wBAAA;IACA,mBAAA;EA+BF;AACF;;AA3BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,4BDzSc;EC0Sd,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA8BF;;AA3BA;EACE,eAAA;EACA,kBAAA;AA8BF;AA7BE;EAHF;IAII,2BAAA;EAgCF;AACF;;AA7BA;EACE,uCAAA;EACA,WAAA;EACA,2BAAA;AAgCF;;AA7BA;EACE,gBAAA;AAgCF;AA/BE;EACE,8BAAA;EACA,QAAA;EACA,mBD/LU;ECgMV,mBAAA;AAiCJ;AA7BI;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBDhVU;ECiVV,YAAA;AA+BN;AA7BM;EACE,oBAAA;AA+BR;AA5BM;EACE,uCAAA;AA8BR;AA5BQ;EACE,YAAA;AA8BV;AAzBM;EArBF;IAsBI,eAAA;EA4BN;AACF;AAxBE;EACE,aAAA;AA0BJ;;AAtBA;EACE,6BAAA;AAyBF;;AApBE;EADF;IAEI,0BAAA;EAwBF;AACF;;AArBA;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;AAwBF;AAvBE;EAJF;IAKI,iBAAA;IACA,WAAA;EA0BF;AACF;AAzBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA2BJ;AAzBE;EACE,eAAA;EACA,gBAAA;AA2BJ;;AAvBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA0BF;AAxBE;EACE,sBAAA;EACA,eAAA;AA0BJ;;AArBA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAwBF;AAvBE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,uBDjaU;AC0bd;AAvBE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBD9aW;ACucf;;AArBA;EACE,mBAAA;AAwBF","sourcesContent":["// ----------------------------- Colors System-----------------------------\n$text-primary: rgb(111, 112, 114);                // #6F7072\n$text-secondary: rgb(52, 52, 52);                 // #343434FF\n$text-tertiary: rgb(66, 66, 67);                  // #424243FF\n$text-graph: rgb(157, 157, 157);                  // #9D9D9DFF\n$red-primary: rgb(194, 27, 23);                   // #C23B33\n$red-secondary: rgb(117, 33, 39);                 // #752127FF\n$red-secondary-light: rgb(238, 144, 123);         // #EE907B\n$red-secondary-dark: rgb(142, 42, 42);            // #8E2A2A\n$red-tertiary: rgb(142, 18, 48);                  // #8E1230FF\n$red-quaternary: rgb(223, 103, 68);               // #DF6744FF\n$red-alt: rgb(224, 146, 141);                     // #E0928DFF\n$red-scrollbar: rgb(239,220,222);                 // #EFDCDEFF\n$red-light: rgb(252, 250, 250);                   // #FCFAFAFF\n$red-lighter: rgb(255, 221, 219);                 // #FFDDDBFF\n$red-lightest: rgb(255, 247, 247);                // #FFF7F7FF\n$red-tomato: rgb(243,98,66);                      // #F36242FF\n$alert-background: rgb(239, 220, 222);            // #EFDCDEFF\n$error-background: rgb(237, 211, 200);            // #EDD3C8FF\n\n$selected-background: rgb(237, 237, 237);         // #EDEDEDFF\n$reason-error-background: rgb(249, 249, 249);     // #F9F9F9FF\n$interaction-btn-background: rgb(255, 245, 244);  // #FFF5F4FF\n\n$dashed-line: rgb(207, 207, 207);                 // #CFCFCFFF\n$shadow: rgb(181, 181, 181);                      // #B5B5B5FF\n$separator: rgb(215, 215, 215);                   // #D7D7D7FF\n$border-color-primary: rgb(151, 151, 151);        // #979797FF\n$color-secondary-contrast-rgba: rgba(255, 255, 255, 0.4); // #FFFFFF66\n$color-medium-rgba: rgba(118,119,122,0.2);        // #76777A33\n$color-medium-tint-rgba: rgba(154,154,154,0.15);\n\n\n$border-color-tertiary: rgb(225, 141, 137);       // #E18D89\n$disabled-color: rgb(214, 219, 225);              // #D6DBE1\n$inactive-color: rgb(160, 160, 160);              // #A0A0A0\n$status-active: rgb(105, 162, 91);                // #69A25BFF\n$status-inactive: $disabled-color;\n$sea-green: rgb(61, 145, 94);                     // #3D915EFF\n$stepper-background: rgb(244, 244, 244);          // #F4F4F4FF\n\n\n// Funds Colors\n$fund-a: rgb(186, 78, 79);                        // #BA4E4FFF\n$fund-b: rgb(243, 174, 2);                        // #F3AE02FF\n$fund-c: rgb(106, 161, 90);                       // #6AA15AFF\n$fund-d: rgb(100, 158, 178);                      // #649EB2FF\n$fund-e: rgb(72, 126, 239);                       // #487EEFFF\n\n$fund-a-light: rgba(186, 78, 79, 0.15);           // #BA4E4F26\n$fund-b-light: rgba(243, 174, 2, 0.15);           // #F3AE0226\n$fund-c-light: rgba(106, 161, 90, 0.15);          // #6AA15A26\n$fund-d-light: rgba(100, 158, 178, 0.15);         // #649EB226\n$fund-e-light: rgba(72, 126, 239, 0.15);          // #487EEF26\n\n// Accounts Colors\n$account-cco: rgb(46, 113, 193);  // CCICO        // #2E71C1FF\n$account-cav: rgb(52, 66, 91);    // CAV          // #34425BFF\n$account-cai: rgb(255, 139, 142); // CAI          // #FF8B8EFF\n$account-ccv: rgb(61, 145, 94);   // CCICV        // #3D915EFF\n$account-cdc: rgb(235, 104, 58);  // CCIDC        // #EB683AFF\n$account-caf: rgb(254, 167, 48);  // CCIAV        // #FEA730FF\n$account-cvc: rgb(97, 73, 170);   // APVC         // #6149AAFF\n\n// Reuses\n$white: white;\n$black: black;\n$text-error: $red-primary;\n\n// New Color System - Figma\n$color-dark-01: rgb(96, 112, 129);               // ##607081\n$color-dark-02: rgb(44, 52, 60);                 // #2C343C\n$color-light-01: rgb(246, 247, 248);             // #F6F7F8\n$color-light-02: rgb(166, 177, 189);             // #A6B1BD\n$color-light-03: rgb(166, 177, 189);             // #A6B1BD\n$color-light-04: rgb(247, 247, 247);             // #F7F7F7\n\n$color-status-success-mid: rgb(6, 194, 112);     // #06C270\n$color-status-success-mid-gamma: rgba(6, 194, 112, 0.2);\n\n// Other\n$red-secondary-degraded: rgb(142, 42, 42);\n$dark-light: rgb(96, 112, 129);\n$grey-mid-dark: rgb(112, 112, 112);               // #707070\n$shadow-lightest: rgba(0, 0, 0, 0.1);\n$collector-color: rgb(238, 93, 100);\n$input-color: rgb(26, 26, 26);\n$red-dark: #930800;\n$transparency: rgba(0, 0, 0, 0.17);\n\n// Profitability colors\n$customer-contribution: rgb(246, 196, 67);         // #F6C443\n$profit: rgb(135, 148, 200);                       // #8794C8\n$withdrawal: rgb(222, 111, 90);                    // #DE6F5A\n\n// Timer colors\n\n$status-alert-mid: rgba(255, 205, 0, 1);\n$status-alert-dark: rgba(117, 98, 1, 1);\n$status-alert-light: rgba(255, 254, 229, 1);\n\n// Elevations\n$elevation-02: 0px 0px 1px rgba(96, 112, 129, 0.2), 0px 1px 4px rgba(96, 112, 129, 0.3);\n$elevation-06: 0px 2px 8px rgba(96, 112, 129, 0.2), 0px 15px 32px rgba(96, 112, 129, 0.3);\n$box-shadow: 0 6px 12px 0 rgba(0,0,0,0.15);\n$box-shadow-04: 0 4px 4px rgba(0,0,0,0.25);\n\n// Gradients\n$header-gradient: linear-gradient(270deg, $red-dark 0%, $red-primary 100%);\n$header-gradient-mobile: linear-gradient(30deg, $red-dark 0%, $red-primary 100%);\n$side-menu-gradient: linear-gradient(238.2deg, $red-primary 0%, #930800 85.46%);\n\n\n\n// ----------------------------- SVG -----------------------------\n\n:root {\n  --icon-valid: url(/assets/icons/i-valid.svg);\n  --icon-invalid: url(/assets/icons/i-invalid.svg);\n}\n\n// Legacy\n\n$turquoise: rgb(61, 142, 145);\n$turquoise-light: rgba(185, 215, 224, 0.3);\n\n$white: rgba(255, 255, 255, 1); // **\n$white-smoke: rgba(239, 239, 239, 0.6); // **\n$white-smoke-transparent: rgba(255, 255, 255, 0.8); // **\n\n$grey-darkest: rgb(51, 51, 51); // **\n$grey-darker: rgb(67, 67, 67); // **\n$grey-dark: rgb(100, 100, 100); // **\n$grey-mid-dark: rgb(107, 107, 107); // **\n$grey: rgb(154, 154, 154);\n$grey-white: rgb(245, 245, 245);\n$grey-white1: #F9F9F9;\n$grey-white2: #EDEDED;\n$grey-white3: #D9D9D9;\n$white-semitransparent: rgba(255, 255, 255, 0.3);\n\n$white-gradient: linear-gradient(180deg, $white 30%, $white-semitransparent 70%);\n\n// Fonts\n$font-regular: \"Roboto-Regular\";\n$font-medium: \"Roboto-Medium\";\n$font-bold: \"Roboto-Bold\";\n\n// Media query\n$break-xs: 360px;\n$break-small-mid: 400px;\n$break-small: 480px;\n$break-medium: 720px;\n$break-large: 795px;\n$break-xlarge-mid: 897px;\n$break-xlarge: 1000px;\n$break-xxlarge-mid: 1220px;\n$break-xxlarge: 1440px;\n$width-mobile: 415px;\n\n// Funds Cards\n$max-width-card: 441px;\n$min-width-card: 300px;\n","@import \"variables.scss\";\n\n.mat-mdc-form-field {\n  padding: 10px;\n\n  .mat-mdc-form-field-infix { padding: 7px 0 3px; }\n  .mat-mdc-form-field-error { text-align: right; }\n}\n\n.login-form {\n  text-align: left;\n  .paragraph {\n    margin-top: 0;\n    @media screen and (max-width: $break-small) { font-size: 12px; }\n    span {\n      color: $red-primary;\n    }\n  }\n\n  .required-field-pharagraph-big {\n    width: 100%;\n    margin-bottom: 15;\n  }\n\n  .required-field-pharagraph-small {\n    width: 100%;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    font-size: 14px;\n  }\n\n  .disabled {\n    color: $disabled-color;\n  }\n\n}\n.column-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .contact-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    margin: 10px 5px 10px;\n    width: 100%;\n\n    .column-inner-container {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      width: 300px;\n      height: 150px;\n\n      &.right {\n        justify-content: flex-start;\n      }\n\n      @media screen and (max-width: $break-xxlarge-mid) {\n        width: 250px;\n      }\n\n      @media screen and (max-width: $break-large) {\n        margin: 0 auto;\n        justify-content: space-around;\n        width: 300px;\n      }\n    }\n\n    @media screen and (max-width: $break-xxlarge-mid) {\n      margin: 15px 0 20px;\n    }\n\n    @media screen and (max-width: $break-large) {\n      flex-direction: column;\n    }\n\n  }\n\n  .message-container {\n    margin: 16px 0 0px;\n    width: 100%;\n    .paragraph {\n      margin-bottom: 1px;\n      font-size: 11px;\n      text-align: center;\n    }\n    h4 {\n      text-align: center;\n      font-size: 17px;\n      font-family: $font-bold;\n      line-height: 19px;\n      color: $red-primary;\n      padding-bottom: 20px;\n      cursor: pointer;\n    }\n  }\n\n  .column-radio-container {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 15px;\n  .radio-label {\n    font-family: $font-bold;\n    color: $red-primary;\n    padding: 8px 0;\n  }\n\n    .radio-button {\n      padding: 10px 0;\n    }\n  }\n\n  .contact-column {\n    width: 45%;\n    min-width: 210px;\n    margin: 5px 5px;\n\n    @media screen and (max-width: $break-medium) {\n      margin: 0;\n    }\n\n    .column-field {\n      width: 100%;\n      height: 84px;\n    }\n\n    @media screen and (max-width: $break-medium) { width: 100%; }\n  }\n\n  @media screen and (max-width: $break-medium) {\n    flex-direction: column;\n  }\n}\n\n.contact-form-picture-container {\n  position: relative;\n  float: left;\n  width: 60%;\n  height: 100vh;\n  padding-top: 20px;\n\n  @media screen and (max-width: $break-xlarge) { display: none; }\n  .contact-form-picture {\n    position: relative;\n    float: left;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n\n    @media screen and (max-width: $break-xlarge) { display: none; }\n  }\n  .concept-pv-grey {\n    position: absolute;\n    left: -50px;\n    top: 220px;\n    background-size: 100%;\n    @media screen and (max-width: $break-xxlarge-mid) {\n      width: 300px;\n    }\n    @media screen and (max-width: $break-xlarge) { display: none; }\n  }\n}\n\n.contact-form-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 80px;\n  justify-content: flex-start;\n  width: 42%;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);\n  height: 100vh;\n\n  @media (max-width: 1000px) {\n    box-shadow: none;\n  }\n\n  @media(min-width: $break-large) {\n    overflow: auto;\n  }\n\n  hr {\n    margin-top: 20px;\n  }\n\n  @media screen and (max-width: $break-xxlarge-mid) {\n    padding-bottom: 20px;\n    &.container-error{\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: $break-large) {\n    height: auto;\n    max-height: 100vh;\n    width: 90%;\n    padding: 40px 5px 0;\n  }\n\n  @media screen and (max-width: $break-small-mid) {\n    width: 100%;\n  }\n\n  @media screen and (max-width: $break-medium) {\n    max-height: max-content;\n  }\n}\n.main-title {\n  text-align: left;\n\n  @media screen and (max-width: $break-small) {\n    text-align: center;\n    width: 80%;\n    margin: 0 auto;\n    padding-bottom: 5px;\n    font-size: 21px;\n  }\n  &.error-title {\n    text-align: center;\n  }\n}\n.main-subtitle {\n  text-align: left;\n  padding-bottom: 20px;\n\n  @media screen and (max-width: $break-small) {\n    text-align: center;\n  }\n  &.error-subtitle {\n    text-align: center;\n  }\n}\n\nre-captcha { margin-top: 20px; }\n\n.error {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.recaptcha-container {\n  margin: 25px 0 0;\n  display: flex;\n  justify-content: space-evenly;\n\n}\n\n.cellphone-hint {\n  font: 14px $font-bold;\n  color: $text-primary;\n}\n\n::ng-deep .mat-select-value-text{\n  color: $text-primary;\n}\n\n.profitability-container {\n  padding: 12px;\n  box-shadow: 0px 0px 1px rgba(96, 112, 129, 0.05), 0px 1px 4px rgba(96, 112, 129, 0.1);\n  border-radius: 10px;\n  width: 100%;\n  background: $color-light-04;\n\n  .profitability-title {\n    font-size: 10px;\n    color: $color-dark-01;\n    font-style: normal;\n    line-height: 12px;\n    margin: 0 !important;\n    font-weight: 400px;\n  }\n  .profitability-content {\n    font-size: 10px;\n    font-weight: 100 !important;\n    line-height: 12px;\n    font-style: normal;\n    margin-top: 7px;\n  }\n  .profitability-link {\n    font-size: 10px;\n    text-decoration: underline;\n  }\n\n  @media screen and (max-width: $break-large) {\n    width: auto;\n  }\n\n  @media (max-width: 1000px) {\n    margin: 0 10px 20px 10px;\n    padding-bottom: 7px;\n  }\n}\n\n\n.btn-alternative {\n  position: absolute;\n  z-index: 2;\n  top: 20px;\n  left: 4%;\n  background: $red-secondary;\n  color: white;\n  width: 93px;\n  height: 42px;\n  border-radius: 25px;\n}\n\n.form-subtitle {\n  margin: 0px 0px;\n  font-style: normal;\n  @media (max-width: 1000px) {\n    margin: 0px 40px !important;\n  }\n}\n\nhr {\n  border: 0.51px solid $selected-background;\n  width: auto;\n  margin: 46px 30px 20px 30px;\n}\n\n::ng-deep .mat-mdc-tab-group {\n  margin-top: 20px;\n  .mat-mdc-tab-header {\n    border-bottom: none !important;\n    gap: 0px;\n    background: $grey-white3;\n    border-radius: 43px;\n  }\n\n  .mat-mdc-tab-labels {\n    .mdc-tab {\n      margin: 4.5px;\n      width: min-content;\n      background: white;\n      border-radius: 25px;\n      color: $text-tertiary;\n      height: 42px;\n\n      .mdc-tab-label-content {\n        white-space: initial;\n      }\n\n      &.mdc-tab--active {\n        background: $red-secondary-dark !important;\n\n        .mdc-tab__text-label {\n          color: white;\n        }\n      }\n\n      \n      @media screen and (max-width: 512px) {\n        font-size: 14px;\n      }\n    }\n  }\n \n  .mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination {\n    display: none;\n  }\n}\n\n::ng-deep .mat-ink-bar {\n  visibility: hidden !important;\n}\n\n\n::ng-deep .mdc-tab {\n  @media (max-width: 512px) {\n    font-size: 12px !important;\n  }\n}\n\n.disclaimer {\n  text-align: center;\n  padding: 10px 0px 0px 0px;\n  width: 100%;\n  @media (max-width: 1000px) {\n    padding: 0px 15px;\n    width: auto;\n  }\n  p {\n    font-size: 14px;\n    font-weight: 100;\n    line-height: 20px;\n  }\n  a {\n    font-size: 14px;\n    font-weight: 100;\n  }\n}\n\n.actions {\n  width: auto;\n  max-width: 100%;\n  text-align: center;\n  padding: 0px 10px;\n\n  .btn-large {\n    width: auto !important;\n    min-width: 100%;\n  }\n\n}\n\n.info-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 74px 0;\n  .info-title {\n    text-align: center;\n    height: 46px;\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 23px;\n    width: 320.64px;\n    color: $red-primary;\n  }\n  .info-description {\n    text-align: center;\n    width: 352px;\n    height: 64px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: $text-primary;\n  }\n}\n\napp-profitability-disclaimer {\n  margin-bottom: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
